// Display names are also used for practices, companies and specialties.
// Keep this separate from userNamePattern, which validates login identifiers.
export const NAME_PATTERN = "^(?=.*[A-Za-zÀ-ÖØ-öø-ÿ0-9])[A-Za-zÀ-ÖØ-öø-ÿ0-9 &'’.,()\\-]{1,50}$";
export const NAME_RULE = 'Use 1 to 50 characters, including at least one letter or number. Spaces, accents, ampersands (&), apostrophes, hyphens, periods, commas and parentheses are allowed.';
